<template>
    <div>
        <div class="container-fluid">
            <!-- Head -->
            <div class="d-flex align-items-center justify-content-between pt-4 mb-4" style="height:72.5px;">
                <div class="d-block">
                    <div class="h1-lg display-tektur m-0">Posibilitas Minimum Jurusan</div>
                    <div v-if="lastUpdated" class="d-block text-sm text-muted mt-1">
                        <i class="fa-solid fa-clock-rotate-left me-2 text-pink"></i>Data terakhir diperbarui: <span class="font-bold text-white">{{ formatLastUpdated(lastUpdated) }}</span>
                    </div>
                </div>
                <div class="d-block" v-if="$parent.$parent.users.role == 'administrator'">
                    <button type="button" v-on:click="$parent.$parent.passing_grade_major_form();" class="btn btn-primary btn-lg btn-s-1">
                        <div class="btn-s-1-inner"><i class="fa-solid fa-circle-plus fa-lg me-3"></i>Tambah Data</div>
                    </button>
                </div>
            </div>
        </div>

        <!-- Data -->
        <div class="card rounded-0 m-0 bg-card-trans-3">
            <div class="card-header">
                <div class="input-group input-group-flush input-group-merge input-group-reverse">
                    <input class="form-control list-search" type="search" placeholder="Cari data disini..." v-model="keywords" v-on:keyup.enter="getData">
                        <span class="input-group-text">
                        <i class="fa-solid fa-search"></i>
                    </span>
                </div>
                <div class="d-flex align-items-center">
                    <div class="d-block me-3 text-muted">Filter:</div>
                    <div class="d-block me-2" style="width:250px;">
                        <div class="form-select-wrapper">
                            <v-select
                                :options="dataUniversity"
                                label="name"
                                v-model="filter.university"
                                placeholder="Semua Universitas"
                                append-to-body
                                @input='set_university'
                                >
                            </v-select>
                        </div>
                    </div>
                    <div class="d-block me-2" style="width:250px;">
                        <div class="form-select-wrapper">
                            <v-select
                                :options="dataMajor"
                                label="name"
                                v-model="filter.major"
                                placeholder="Semua Jurusan"
                                append-to-body
                                @input='set_major'
                                >
                            </v-select>
                        </div>
                    </div>
                    <div class="d-bloc me-2" style="width:250px;">
                        <select class="form-select form-select-dark" v-model="education_level" v-on:change="getData()">
                            <option value="">Semua Jenjang</option>
                            <option v-for="(item, index) in dataEducationLevel" :key="index" :value="item">{{ item }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="dataFetch" class="container-fluid mt-4">
            <div class="card">
                <div class="card-body">
                    <div class="d-block text-center py-4">
                        <div class="d-block mb-2 text-muted"><i class="fa-solid fa-spin fa-spinner fa-lg"></i></div>
                        <div class="d-block text-sm text-muted ">Loading...</div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="!dataFetch && dataList.length > 0" class="card rounded-0 m-0 bg-card-trans-3">
            <div data-simplebar class="table-responsive" style="overflow-y:auto; height:72.9vh;">
                <table class="table table-sm table-hover card-table th-sticky table-sm-th">
                    <thead>
                        <tr>
                            <th class="text-center">No</th>                                
                            <th>Universitas </th>
                            <th>Jurusan</th>
                            <th>Jenjang</th>
                            <th>Provinsi</th>
                            <th>Rumpun</th>
                            <th>Prasyarat</th>
                            <th>Posibilitas Minimum</th>
                            <th>Kuota/Peminat</th>
                            <th v-if="$parent.$parent.users.role == 'administrator'" class="text-center">Tergenerate</th>
                            <th v-if="$parent.$parent.users.role == 'administrator'"></th>
                        </tr>
                    </thead>                    
                    <tbody class="text-sm">
                        <tr v-for="(item, index) in dataList" :key="index">
                            <td class="text-center">
                                {{ (index + 1) + (pagination.current_page - 1) * pagination.limit }}
                            </td>
                            <td>
                                <div class="d-block text-sm font-bold">{{ item.university_name }}<i class="fa-solid fa-circle-info fa-sm ms-2 text-pink" data-bs-toggle="tooltip" data-bs-placement="top" aria-label="Universitas Dipenogoro" data-bs-original-title="Universitas Dipenogoro"></i></div>
                            </td>     
                            <td class="font-bold">
                                <div class="d-block font-bold mb-2 text-sm">{{item.major_name}}</div>
                                <div class="d-block">
                                    <div class="badge border">Kode {{ item.major_code }}</div>
                                </div>
                            </td>
                            <td class="text-center">{{ (item.education_level ? item.education_level : '-') }}</td>
                            <td>{{ item.province_name }}</td>
                            <td>{{ item.group_subject_name }}</td>
                            <td>
                                <div class="d-flex flex-wrap">
                                    <div v-for="(itemDetail, indexDetail) in item.subject_list" :key="indexDetail" class="d-flex align-items-center py-2 px-3 border rounded me-2 my-1 text-sm">
                                        <div class="me-2">{{ itemDetail.name }}</div>
                                        <div class="box-score box-score-sm d-none">
                                            <span>{{ itemDetail.score }}</span>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-block pb-2 mb-3 border-bottom">
                                    <div class="d-block small">Rapor</div>
                                    <div class="d-block"><span class="display-tektur h2 text-pink">{{ item.pg_rapor }}</span></div>
                                </div>
                                <div class="d-block">
                                    <div class="d-block small">UTBK</div>
                                    <div class="d-block"><span class="display-tektur h2 text-pink">{{ item.pg_utbk }}</span></div>
                                </div>
                            </td>
                            <td>
                                <div class="d-block pb-2 mb-3 border-bottom">
                                    <div class="d-block small">SNBP</div>
                                    <div class="d-block">
                                        {{item.snbp_quota}}/{{item.snbp_applicants}}<i class="fa-solid fa-caret-right fa-sm mx-2 text-pink"></i>1:{{ item.snbp_comparison }}
                                    </div>
                                </div>
                                <div class="d-block">
                                    <div class="d-block small">SNBT</div>
                                    <div class="d-block">
                                        {{item.snbt_quota}}/{{item.snbt_applicants}}<i class="fa-solid fa-caret-right fa-sm mx-2 text-pink"></i>1:{{ item.snbt_comparison }}
                                    </div>
                                </div>
                            </td>
                            <td v-if="$parent.$parent.users.role != 'teacher'" class="text-center">
                                <span class="display-tektur h2">{{ item.total_generate }} / {{ item.total_alumni }}</span>
                            </td>
                            <td v-if="$parent.$parent.users.role != 'teacher'">
                                <div class="d-flex align-items-center">
                                    <button v-on:click="$parent.$parent.passing_grade_major_form(item.id);" type="button" class="btn btn-white-naked btn-sm me-2" data-bs-toggle="tooltip" data-bs-placement="top" title="Edit">
                                        <i class="fa-solid fa-pencil"></i>
                                    </button>
                                    <button v-on:click="deleteData(item.id)" type="button" class="btn btn-white-naked btn-sm text-danger" data-bs-toggle="tooltip" data-bs-placement="top" title="Delete">
                                        <i class="fa-solid fa-trash-can"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div aria-label="navigation" class="card-footer d-flex justify-content-between">

                <!-- Pagination (prev) -->
                <ul class="list-pagination-prev pagination pagination-tabs card-pagination">
                    <li class="page-item">
                        <a class="page-link ps-0 pe-4 border-end border-c-1" :class="pagination.current_page <= 1 ? 'disabled':''" href="javascript:void(0)" v-on:click="pagination_handle('prev')">
                            <i class="fa-solid fa-angle-left me-3"></i>Sebelumnya
                        </a>
                    </li>
                </ul>

                <v-pagination v-model="pagination.current_page" :page-count="pagination.total_pages" :classes="pagination.style" :labels="pagination.anchor_text" v-on:change="getData()"></v-pagination>

                <!-- Pagination (next) -->
                <ul class="list-pagination-next pagination pagination-tabs card-pagination">
                    <li class="page-item">
                        <a class="page-link ps-4 pe-0 border-start border-c-1" :class="pagination.current_page >= pagination.total_pages ? 'disabled':''" href="javascript:void(0)" v-on:click="pagination_handle('next')">
                            Selanjutnya<i class="fa-solid fa-angle-right ms-3"></i>
                        </a>
                    </li>
                </ul>

            </div>            
        </div>

        <!-- Empty -->
        <div v-if="!dataFetch && emptyState" class="container-fluid mt-4">
            <div class="card">
                <div class="card-body">
                    <div class="d-block text-center py-4">
                        <div class="d-block mb-2 text-pink"><i class="fa-solid fa-triangle-exclamation fa-lg"></i></div>
                        <div class="d-block text-sm text-muted ">Data tidak ditemukan.</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vPagination from 'vue-plain-pagination'
export default {
    name: 'PassingGradeMajorMain',
    metaInfo: {
        title: 'Posibilitas Minimum Jurusan',
        titleTemplate: '%s - Rasionalisasi Rapor'
    },
    components: {
        vPagination
    },
    data() {
        return {
            filter : {
                university : [],
                major      : []
            },
            emptyState  : false,
            dataFetch   : false,
            dataList    : [],
            lastUpdated : null,
            keywords    : "",
            pagination: {
                current_page    : 1,
                total_pages     : 0,
                limit           : 50,
                style: {
                    ul: 'list-pagination pagination pagination-tabs card-pagination',
                    li: 'page-item',
                    a: 'page',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'                
                },
                anchor_text: {
                    first: '',
                    prev: '',
                    next: '',
                    last: ''
                }
            },
            dataUniversity : [],
            university_id : '',
            dataMajor : [],
            major_id : '',
            dataEducationLevel : ['D3','D4','S1'],
            education_level : ''
        }
    },
    created() {
        this.getData();
        this.getUniversity();
        this.getMajor();
    },
    methods: {
        getData: function() {
            let uri         = process.env.VUE_APP_APIHOST+'passing-grade-major/list';

            this.dataFetch  = true;                
            this.$http.get(uri,{
                params : {
                    keywords : this.keywords,
                    page     : this.pagination.current_page,
                    limit    : this.pagination.limit,
                    university_id   : this.university_id,
                    major_id   : this.major_id,
                    education_level : this.education_level
                }
            }).then(res => {
                this.emptyState                 = false;
                this.dataFetch                  = false;                
                this.dataList                   = res.data.data;
                this.pagination.total_pages     = res.data.total_page;
                this.lastUpdated                = res.data.last_updated || null;

                if(this.dataList.length < 1) {
                    this.emptyState = true;
                }
            });
        },
        // "2026-04-16 11:54:57" -> "16 April 2026, 11:54 WIB".
        // Parsed by hand: Safari cannot parse "Y-m-d H:i:s" with new Date().
        formatLastUpdated: function(value) {
            const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/);
            if (!match) {
                return value;
            }

            const months = ['Januari','Februari','Maret','April','Mei','Juni','Juli','Agustus','September','Oktober','November','Desember'];
            const date   = parseInt(match[3], 10) + ' ' + months[parseInt(match[2], 10) - 1] + ' ' + match[1];

            return match[4] ? date + ', ' + match[4] + ':' + match[5] + ' WIB' : date;
        },
        pagination_handle: function(params) {
            if(params == 'next') {
                if(this.pagination.current_page < this.pagination.total_pages) {
                    this.pagination.current_page = this.pagination.current_page+1;
                    this.getData();
                }
            }

            if(params == 'prev') {
                if(this.pagination.current_page > 1) {
                    this.pagination.current_page = this.pagination.current_page-1;
                    this.getData();
                }
            }
        },
        deleteData: function (id) {
            this.$swal({
                icon: 'info',
                title: 'Hapus Data',
                text: 'Apakah kamu yakin ingin menghapus data ini?',
                confirmButtonText: 'Hapus',
                showCancelButton: true,
                cancelButtonText: 'Batal',
            }).then((result) => {
            if (result.value) {
                this.$http.post(process.env.VUE_APP_APIHOST + 'passing-grade-major/delete', {
                    id: id
                })
                .then(response => {
                    if (response.data.status) {
                        this.$swal({
                            icon: 'success',
                            title: 'Success',
                            text: response.data.message,
                            confirmButtonText: 'OK'
                        }).then((result) => {
                            if (result.value) {
                                this.getData();
                            }
                        });
                    } else {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: response.data.message,
                    });
                    }
                })
            }
            });
        },
        getUniversity: function() {
            let uri         = process.env.VUE_APP_APIHOST+'university/list';
            this.$http.get(uri,{
                params : {
                    limit    : 1000
                }
            }).then(res => {
                this.dataUniversity = res.data.data;
            });
        },
        getMajor: function() {
            let uri         = process.env.VUE_APP_APIHOST+'master-major/list';
            this.$http.get(uri).then(res => {
                this.dataMajor = res.data.data;
            });
        },
        set_university: function() {
            if (this.filter.university !== undefined && this.filter.university !== null) {
                this.university_id = this.filter.university.id;
            }  else {
                this.university_id = "";
            }
            this.getData();
        },
        set_major: function() {
            if (this.filter.major !== undefined && this.filter.major !== null) {
                this.major_id = this.filter.major.id;
            }  else {
                this.major_id = "";
            }
            this.getData();
        },
    }
}
</script>
